import React from 'react';
import { getTranslation } from '../../../../utils/translation';

export default function Table({ data, openPage }) {
    const columns = data?.metadata?.columns;
    const rows = data?.rows;

    return (
        <table className={'point-table point-table--sportsbook'}>
            <thead>
                <tr align='center'>{columns && columns.map(c => <th key={c}>{c}</th>)}</tr>
            </thead>
            <tbody>
                {rows &&
                    rows.map(r => {
                        return (
                            <tr key={r[0]} align='center'>
                                <td className='td-number'>{r[0]}</td>
                                <td>{r[1]}</td>
                                <td>
                                    <a href={'#'} onClick={() => openPage(r[2])}>
                                        <button className='downloadBtn'>
                                            {getTranslation('sportsbookPreviewButton')}
                                        </button>
                                    </a>
                                </td>
                                <td>
                                    <a href={'#'} onClick={() => openPage(r[3])}>
                                        <button className='downloadBtn'>
                                            {getTranslation('sportsbookPreviewButton')}
                                        </button>
                                    </a>
                                </td>
                                <td>
                                    <a href={'#'} onClick={() => openPage(r[4])}>
                                        <button className='downloadBtn'>
                                            {getTranslation('sportsbookPreviewButton')}
                                        </button>
                                    </a>
                                </td>
                                <td>
                                    <a href={'#'} onClick={() => openPage(r[5])}>
                                        <button className='downloadBtn'>
                                            {getTranslation('sportsbookPreviewButton')}
                                        </button>
                                    </a>
                                </td>
                            </tr>
                        );
                    })}
            </tbody>
        </table>
    );
}
